// extracted by mini-css-extract-plugin
export default {"dataWrapper":"userData_dataWrapper__PYMgO","data":"userData_data__uimOg"};